import { EntityType } from '@frontend/common';
import { Identification } from '@frontend/identification/types';
import { IUser } from '@frontend/user/types';
import { useState } from 'react';

import { useIdentification } from '../../../hooks/useIdentification/useIdentification';
import { useScreen } from '../useScreen';

export interface IdentifyBadgeViewProps {
    resolving: boolean;
    error: string | null;
    resetError: () => void;
    onBack: () => void;
}

export const useIdentifyBadge = (): IdentifyBadgeViewProps => {
    const { onSubmit, onBack, updateWizardData } = useScreen();
    const [resolving, setResolving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const handleBadgeIdentified = (badge: Identification, data?: any) => {
        const linkedUser = (data?.user as IUser | undefined) ?? (data?.data?.user as IUser | undefined) ?? null;
        const badgeLinked = badge.entity_type === EntityType.USER && !!badge.entity_id;

        setResolving(false);
        setError(null);
        updateWizardData({
            badge,
            badgeKey: badge.key,
            badgeLinked,
            linkedUser: linkedUser?.id === badge.entity_id ? linkedUser : null
        });
        onSubmit();
    };

    const handleNoMatchingIdentificationFound = (data?: any) => {
        const key = data?.input ?? data?.data?.input ?? null;
        setResolving(false);
        updateWizardData({
            badge: null,
            badgeKey: key,
            badgeLinked: null,
            linkedUser: null
        });
        onSubmit();
    };

    useIdentification({
        id: 'IDENTIFY_BADGE',
        onBadgeIdentified: handleBadgeIdentified,
        onNoMatchingIdentificationFound: handleNoMatchingIdentificationFound,
        onUnlinkedIdentificationFound: handleNoMatchingIdentificationFound
    });

    return {
        resolving,
        error,
        resetError: () => setError(null),
        onBack
    };
};
